import type { ReactNode } from "react";

/**
 * Break-glass: a floor on the wizard body's height.
 *
 * The modify-broker wizard swaps between an address page and a much shorter
 * contact page. Without a minimum height the dialog visibly shrinks and grows
 * as you step through it. A min-height is not something any layout primitive
 * can express — Stack/Row only distribute space they are given — so it stays
 * as a class here rather than leaking into the dialog.
 */
export function BrokersModifyDialogBody({ children }: { children: ReactNode }) {
  return <div className="min-h-[330px]">{children}</div>;
}
